module.exports = __webpack_public_path__ + "static/img/login_img.0da15e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login_img.png
// module id = qA5R
// module chunks = 0